import React from "react";

function FormulaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41.36"
      height="34.507"
      viewBox="0 0 41.36 34.507"
    >
      <g fill="#78a1bb" data-name="Group 133">
        <path
          d="M152.645 919.294l-3.623-2.345a.509.509 0 00-.785.427v.988h-6.953c-.385-.838-.756-1.7-1.122-2.554-1.887-4.391-3.833-8.916-7.456-9.787v-5.141h.988a.509.509 0 00.427-.785l-2.345-3.623a.509.509 0 00-.854 0l-2.345 3.623a.509.509 0 00.427.785h.988v5.175c-3.536.95-5.456 5.417-7.319 9.753-.366.853-.738 1.716-1.122 2.554h-9.526a.509.509 0 00-.509.509v1.7a.509.509 0 00.509.509h8.144c-.259.446-.527.869-.805 1.258-1.367 1.908-2.8 2.8-4.5 2.8v1.018c2.942 0 4.888-2.186 6.473-5.072h8.654v9.064a.509.509 0 00.509.509h1.7a.509.509 0 00.509-.509v-9.064h8.791c1.585 2.886 3.531 5.072 6.474 5.072v-1.018c-1.7 0-3.134-.889-4.5-2.8a15.634 15.634 0 01-.805-1.258h5.571v.988a.509.509 0 00.785.427l3.623-2.345a.509.509 0 000-.854zm-3.391 1.837v-.562a.509.509 0 00-.509-.509h-6.638q-.173-.333-.341-.678h6.98a.509.509 0 00.509-.509v-.561l2.178 1.41zm-16.548-1.07h-10.835q.167-.335.33-.678h18.436q.163.343.33.678zm-1.018 9.573h-.678v-8.555h.678zm-19.154-10.251h8.535q-.169.344-.341.678h-8.194zm17.966-19.518h-.562l1.409-2.178 1.409 2.178h-.556a.509.509 0 00-.509.509v5.507c-.089 0-.179-.007-.271-.007q-.207 0-.407.014v-5.514a.509.509 0 00-.513-.509zm.916 7.026c.091 0 .181 0 .271.008v11.465h-.678v-11.455c.136-.009.272-.018.409-.018zm4.5 2.8a36.438 36.438 0 013.309 6.525c.309.719.62 1.442.939 2.152h-7.46v-11.29a6.343 6.343 0 013.215 2.61zm-12.31 6.525a36.433 36.433 0 013.308-6.525 6.475 6.475 0 013.076-2.566v11.243h-7.32c.319-.713.63-1.436.939-2.155z"
          data-name="Path 195"
          transform="translate(-111.518 -896.144)"
        ></path>
        <path
          d="M392.087 898.21a.3.3 0 01-.053.146 1.165 1.165 0 01-.419.406 1.616 1.616 0 01-.439.173l.219.852a1.777 1.777 0 00.972-.446 4.949 4.949 0 001.145-2.136l.759-2.143h-1.078l-.406 1.6c-.047.193-.1.433-.14.612h-.026c-.04-.173-.107-.419-.16-.606l-.486-1.6h-1.125l1.2 2.982a.411.411 0 01.037.16z"
          data-name="Path 196"
          transform="translate(-367.122 -895.062)"
        ></path>
        <path
          d="M548.879 1091.316l.306-.586c.08-.16.166-.319.246-.492h.02c.08.166.16.333.253.492l.326.586h1.145l-1.085-1.7 1.072-1.551h-1.1l-.286.532c-.086.16-.166.319-.253.5h-.013c-.086-.16-.173-.319-.266-.486l-.319-.546h-1.131l1.078 1.6-1.1 1.657z"
          data-name="Path 197"
          transform="translate(-510.694 -1071.664)"
        ></path>
      </g>
    </svg>
  );
}

export default FormulaIcon;